import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_helpers";
import {Alert } from "react-bootstrap";

export const IFrameRequested = (props) => {

    return (
        <>
            <div
                className="row align-content-start position-relative"
                style={{ minHeight: "80vh" }}
            >
                <div className="col-12">
                    <h3>
                        {(() => {
                            if (props.feed_type === "API") {
                                return props.language.DIAMOND_FEED_API;
                            } else if (props.feed_type === "SHOPIFY APP") {
                                return props.language.DIAMOND_FEED_SHOPIFY_APP;
                            } else if (props.feed_type === "SHOPIFY APP RING") {
                                return props.language.DIAMOND_FEED_SHOPIFY_RING_APP;
                            } else if (
                                props.feed_type === "WOOCOMMERCE PLUGIN"
                            ) {
                                return props.language
                                    .DIAMOND_FEED_WOOCOMMERCE_PLUGIN;
                            } else {
                                return props.language
                                    .DIAMOND_FEED_IFRAME_PLUGIN;
                            }
                        })()}{" "}
                        {props.language.DIAMOND_FEED_IFRAME_REQUESTEDMSG1}
                    </h3>
                    <Alert className="my-5" variant="success">
                        {props.language.DIAMOND_FEED_IFRAME_REQUESTEDMSG2}{" "}
                        {(() => {
                            if (props.feed_type === "API") {
                                return props.language.DIAMOND_FEED_API;
                            } else if (props.feed_type === "SHOPIFY APP") {
                                return props.language.DIAMOND_FEED_SHOPIFY_APP;
                            } else if (props.feed_type === "SHOPIFY APP RING") {
                                return props.language.DIAMOND_FEED_SHOPIFY_RING_APP;
                            } else if (
                                props.feed_type === "WOOCOMMERCE PLUGIN"
                            ) {
                                return props.language
                                    .DIAMOND_FEED_WOOCOMMERCE_PLUGIN;
                            } else {
                                return props.language
                                    .DIAMOND_FEED_IFRAME_PLUGIN;
                            }
                        })()}{" "}
                        {props.language.DIAMOND_FEED_IFRAME_REQUESTEDMSG3}{" "}
                        {(() => {
                            if (props.feed_type === "API") {
                                return props.language.DIAMOND_FEED_API;
                            } else if (props.feed_type === "SHOPIFY APP") {
                                return props.language.DIAMOND_FEED_SHOPIFY_APP;
                            } else if (props.feed_type === "SHOPIFY APP RING") {
                                return props.language.DIAMOND_FEED_SHOPIFY_RING_APP;
                            } else if (
                                props.feed_type === "WOOCOMMERCE PLUGIN"
                            ) {
                                return props.language
                                    .DIAMOND_FEED_WOOCOMMERCE_PLUGIN;
                            } else {
                                return props.language
                                    .DIAMOND_FEED_IFRAME_PLUGIN;
                            }
                        })()}{" "}
                        {props.language.DIAMOND_FEED_IFRAME_REQUESTEDMSG4}.
                    </Alert>
                    <p className="text-muted">
                        {props.language.DIAMOND_FEED_IFRAME_REQUESTEDMSG2}{" "}
                        {(() => {
                            if (props.feed_type === "API") {
                                return props.language.DIAMOND_FEED_API;
                            } else if (props.feed_type === "SHOPIFY APP") {
                                return props.language.DIAMOND_FEED_SHOPIFY_APP;
                            } else if (props.feed_type === "SHOPIFY APP RING") {
                                return props.language.DIAMOND_FEED_SHOPIFY_RING_APP;
                            } else if (
                                props.feed_type === "WOOCOMMERCE PLUGIN"
                            ) {
                                return props.language
                                    .DIAMOND_FEED_WOOCOMMERCE_PLUGIN;
                            } else {
                                return props.language
                                    .DIAMOND_FEED_IFRAME_PLUGIN;
                            }
                        })()}{" "}
                        {props.language.DIAMOND_FEED_IFRAME_REQUESTEDMSG3}{" "}
                        {(() => {
                            if (props.feed_type === "API") {
                                return props.language.DIAMOND_FEED_API;
                            } else if (props.feed_type === "SHOPIFY APP") {
                                return props.language.DIAMOND_FEED_SHOPIFY_APP;
                            } else if (props.feed_type === "SHOPIFY APP RING") {
                                return props.language.DIAMOND_FEED_SHOPIFY_RING_APP;
                            } else if (
                                props.feed_type === "WOOCOMMERCE PLUGIN"
                            ) {
                                return props.language
                                    .DIAMOND_FEED_WOOCOMMERCE_PLUGIN;
                            } else {
                                return props.language
                                    .DIAMOND_FEED_IFRAME_PLUGIN;
                            }
                        })()}{" "}
                        {props.language.DIAMOND_FEED_IFRAME_REQUESTEDMSG4}.
                    </p>
                    <p className="text-muted">
                        {props.language.DIAMOND_FEED_IFRAME_REQUESTEDMSG5}{" "}
                        {(() => {
                            if (props.feed_type === "API") {
                                return props.language.DIAMOND_FEED_API;
                            } else if (props.feed_type === "SHOPIFY APP") {
                                return props.language.DIAMOND_FEED_SHOPIFY_APP;
                            } else if (props.feed_type === "SHOPIFY APP RING") {
                                return props.language.DIAMOND_FEED_SHOPIFY_RING_APP;
                            } else if (
                                props.feed_type === "WOOCOMMERCE PLUGIN"
                            ) {
                                return props.language
                                    .DIAMOND_FEED_WOOCOMMERCE_PLUGIN;
                            } else {
                                return props.language
                                    .DIAMOND_FEED_IFRAME_PLUGIN;
                            }
                        })()}
                        .
                    </p>
                    <p className="text-muted">
                        {props.language.DIAMOND_FEED_IFRAME_REQUESTEDMSG6}
                    </p>
                </div>
                <div className="api-home-svg api-success">
                    <SVG
                        src={toAbsoluteUrl(
                            "/media/General/diamond_feed_request.svg"
                        )}
                    />
                </div>
            </div>
        </>
    );
};
